import React from 'react'
import './Service_Banner.css'
import Common_Banner_2 from '../../../common_components/common_banner_2/Common_Banner_2'

const Service_Banner = ({imgSrc, title_text, breadcrumbs}) => {
  return (
    <div className='Service_Banner'>
            <Common_Banner_2 imgSrc={imgSrc} title_text={title_text} breadcrumbs={breadcrumbs}/>
    </div>
  )
}

export default Service_Banner
